import { logger } from '@zep/core-logger';

/** code-login 진입 경로 축. typing=코드직접입력, scan=앱내카메라, link=딥링크자동검증 */
export type CodeLoginMethod = 'typing' | 'scan' | 'link';

export interface CodeLoginAnalyticsParams {
  login_method?: CodeLoginMethod;
  [key: string]: unknown;
}

export const trackCodeLoginEvent = (
  eventName: string,
  params: CodeLoginAnalyticsParams = {},
) => {
  logger.track(eventName, { feature: 'code_login', ...params });
};
